import React from 'react'
import {Container, Row, FormControl} from 'react-bootstrap'
import CardProduk from 'components/dashboard/dashcomp/card_produk'
import {Link} from 'react-router-dom'
import './style.css'

export default function detilsProduk() {
    return (
        <Container className="detils-produk-page">
            <h3>
                <span> 
                    <Link to="#">Buku Islami</Link> 
                    <img src="asset/category/vector.svg" alt="vector" />
                </span> 
                Al-Qur’an
            </h3>
            <FormControl className="input" placeholder="Cari di Halaman Kategori ..." />
            <Row>
                {
                    NewProduk.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`asset/category/${item.src + i}.png`} 
                            alt="qur'an"
                            text={item.text} potongan={item.potongan}
                            price={item.price} cProduk="footers"
                            />
                        )
                    })
                }
            </Row>
            </Container>
    )
}


const NewProduk = [
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"},
    {src:"qur'an", text:"Alquran Hafalan Terjemah Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000"}
]
